import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {DahDocument, DahDocumentSearchParams} from '@documents/_common/models/dah-documents.models';
import {CategoryListResponse, EntityCategoryTree} from '@common/components-standalone/reference-category-module/category.type';
import {CategoriesTreeState} from '@common/models/entity-state.models';

export const CheckState = createAction(
    '[DahDocuments] Check State',
    props<{ payload: { close: boolean, items: DahDocument[] } }>()
);

export const CheckStateSuccess = createAction(
    '[DahDocuments] Check State Success',
    props<{ payload: { close: boolean, items: DahDocument[] } }>()
);

export const LoadCategories = createAction(
    '[DahDocuments] Load Categories',
    props<{ forceUpdate: boolean }>()
);

export const LoadCategoriesSuccess = createAction(
    '[DahDocuments] Load Categories Success',
    props<{ payload: CategoryListResponse[] }>()
);

export const SetCategoriesState = createAction(
    '[DahDocuments] Set Categories State',
    props<{ payload: CategoriesTreeState }>()
);

export const LoadList = createAction(
    '[DahDocuments] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[DahDocuments] Load List Success',
    props<{ payload: { items: DahDocument[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[DahDocuments] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[DahDocuments] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[DahDocuments] Set Filter',
    props<{ payload: DahDocumentSearchParams, selectedCategory?: EntityCategoryTree }>()
);

export const SetLoading = createAction(
    '[DahDocuments] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[DahDocuments] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[DahDocuments] Update Item Success',
    props<{ payload: DahDocument }>()
);

export const SetInitialState = createAction(
    '[DahDocuments] Set Initial State'
);
